module.exports = __webpack_public_path__ + "img/landscape_night_sky_3.b3650c90.jpg";